export const patientTabs = [
    { id: 1, name: 'My Prescriptions', link: '/patient/my-prescriptions'},
    { id: 2, name: 'Green Resources', link: '/patient/green-resources'},
];

export const prescriberTabs = [
    { id: 3, name: 'My Prescriptions', link: '/prescriber/my-prescriptions'},
    { id: 4, name: 'Green Resources', link: '/prescriber/green-resources'},
];

export const adminTabs = [
    { id: 5, name: 'Verification', link: '/admin/verification'},
    { id: 6, name: 'Profiles', link: '/admin/profiles'},
];